import axios from "axios";

const state = {
    cargasmasivas: null,
    totalPaginas: null,
};

const getters = {
    cargasmasivas: (state) => state.cargasmasivas,
    totalPaginas: (state) => state.totalPaginas,
};

const mutations = {
    setCargasmasivas: (state, cargasmasivas) => {
        state.cargasmasivas = cargasmasivas;
    },

    setTotalPaginas: (state, data) => {
        state.totalPaginas = data;
    },
};

const actions = {

    async consultar({commit}) {
        try {
            let res = await axios.get(`/v1/inventario-carga`);
            commit("setCargasmasivas", res?.data?.result.solicitudes);
        } catch (error) {
            return error;
        }
    },
    async consultarPagina({commit}, data) {
        try {
            let res = await axios.get(`/v1/inventario-carga/pagina/${data.pagina}`);
            commit("setCargasmasivas", res?.data?.result);
        } catch (error) {
            return error;
        }
    },
    async consultarTotalPagina({commit}) {
        try {
            let res = await axios.get(`/v1/inventario-carga/total`);
            commit("setTotalPaginas", res?.data);
        } catch (error) {
            return error;
        }
    },
    async cargarArchivo({commit}, data) {
        try {
            const headers = { 'Content-Type': 'multipart/form-data' };
            const resp = await axios.post(`/v1/inventario-carga/upload`, data, { headers });
            commit("setMensaje", "Se ha cargado con éxito el archivo");
            return {
                success: true,
                data: resp.data,
            }
        } catch (error) {
            return {
                success: false,
                data: error.response.data.errors
            }
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
